// extracted by css-extract-rspack-plugin
export default {"hiddenNotice":"IssueCommentItem-module__hiddenNotice__pgeA0","unhideLabel":"IssueCommentItem-module__unhideLabel__Z2rM8","unhideIcon":"IssueCommentItem-module__unhideIcon__bEiT0"};